/*
  Alpine `builds` component for the inspiration gallery — extracted from snippets/inspiration-2026.liquid so it
  ships from a cacheable, deferred asset.

  The builds metaobject payload stays in the page (it is Liquid data) and is read from the
  #inspiration-builds-data JSON block. This file runs before alpine.min.js in document order,
  so the alpine:init listener is still registered in time.
*/
function inspirationBuildsData() {
  var node = document.getElementById('inspiration-builds-data');
  if (!node) return [];
  try {
    return JSON.parse(node.textContent);
  } catch (error) {
    return [];
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('builds', () => ({
    activeBuild: '',
    activeBuildNugget: 'nugget-1',
    activeBuildChunk: 'chunk-1',
    activeBuildSmore: 'smore-0',
    builds: inspirationBuildsData(),

    init() {
      const url = new URL(window.location.href);

      const hasAnyParam =
        url.searchParams.get('nugget') !== null ||
        url.searchParams.get('chunk') !== null ||
        url.searchParams.get('smore') !== null;

      const nuggetQty = url.searchParams.get('nugget') ?? (hasAnyParam ? '0' : '1');
      const chunkQty  = url.searchParams.get('chunk')  ?? (hasAnyParam ? '0' : '1');
      const smoreQty  = url.searchParams.get('smore')  ?? '0';

      this.activeBuildNugget = `nugget-${nuggetQty}`;
      this.activeBuildChunk = `chunk-${chunkQty}`;
      this.activeBuildSmore = `smore-${smoreQty}`;
      this.activeBuild = this.rebuildActiveBuild();

      // keep the URL normalized
      url.searchParams.set('nugget', nuggetQty);
      url.searchParams.set('chunk', chunkQty);
      url.searchParams.set('smore', smoreQty);
      window.history.replaceState({}, '', url.toString());
    },

    buildKeys() {
      // new explicit key: always keep the 0s
      const fullKey = [
        this.activeBuildNugget,
        this.activeBuildChunk,
        this.activeBuildSmore
      ].join('-');

      // legacy compact key: keeps old Nugget/Chunk behavior working
      const compactParts = [];

      if (this.activeBuildNugget !== 'nugget-0') compactParts.push(this.activeBuildNugget);
      if (this.activeBuildChunk !== 'chunk-0') compactParts.push(this.activeBuildChunk);
      if (this.activeBuildSmore !== 'smore-0') compactParts.push(this.activeBuildSmore);

      const compactKey = compactParts.length ? compactParts.join('-') : fullKey;

      return [...new Set([fullKey, compactKey])];
    },

    rebuildActiveBuild() {
      // primary active key is always the full explicit version
      return this.buildKeys()[0];
    },

    matchesBuild(type, quantity) {
      const buildKey = String(quantity) !== '100'
        ? `${type}-${quantity}`
        : type;

      return this.buildKeys().includes(buildKey);
    },

    hasMatchingBuild() {
      return this.builds.some((build) => this.matchesBuild(build.type, build.quantity));
    },

    handleBuildClick(type, quantity) {
      if (type === 'nugget') {
        this.activeBuildNugget = `${type}-${quantity}`;
      }

      if (type === 'chunk') {
        this.activeBuildChunk = `${type}-${quantity}`;
      }

      if (type === 'smore') {
        this.activeBuildSmore = `${type}-${quantity}`;
      }

      this.activeBuild = this.rebuildActiveBuild();

      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('nugget', this.activeBuildNugget.split('-')[1]);
      currentUrl.searchParams.set('chunk', this.activeBuildChunk.split('-')[1]);
      currentUrl.searchParams.set('smore', this.activeBuildSmore.split('-')[1]);
      window.history.replaceState({}, '', currentUrl.toString());
    }
  }))
})
